import { Outlet } from 'react-router-dom'
import Navbar from './components/navbar'
import Footer from './components/Footer'

function ReaderLayout() {
  return (
    <div className="min-h-screen bg-canvas flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

export default ReaderLayout
